import request from '@/services/interceptor.js'


export const login_doc = par => {
  return request({
    url: '/api/doc/login/' + par,
    method: 'get'
  })
}

export const get_doc = () => {
  return request({
    url: '/api/doc/data',
    method: 'get'
  })
}